module.exports = __webpack_public_path__ + "img/findme.8b1c7d8b.jpg";